import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=6704cacc"
import script from "./CoverImage.vue?vue&type=script&lang=js"
export * from "./CoverImage.vue?vue&type=script&lang=js"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=6704cacc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports